import React from "react"
import { cn } from "@/lib/utils"

interface IPhoneFrameProps {
  children: React.ReactNode
  className?: string
}

export function IPhoneFrame({ children, className }: IPhoneFrameProps) {
  return (
    <div className={cn("relative", className)}>
      {/* iPhone outer frame with realistic styling */}
      <div className="relative bg-gradient-to-b from-[#2a2a2a] to-[#1a1a1a] rounded-[2.5rem] p-[3px] shadow-[0_25px_50px_-12px_rgba(0,0,0,0.4)]">
        {/* Subtle highlight on top edge */}
        <div className="absolute inset-x-4 top-0 h-[1px] bg-gradient-to-r from-transparent via-white/20 to-transparent" />
        
        {/* iPhone inner bezel */}
        <div className="relative bg-black rounded-[2.3rem] overflow-hidden">
          {/* Dynamic Island */}
          <div className="absolute top-3 left-1/2 -translate-x-1/2 z-20">
            <div className="w-[90px] h-[28px] bg-black rounded-full flex items-center justify-center gap-2 shadow-inner">
              <div className="w-[10px] h-[10px] rounded-full bg-[#1a1a1c] ring-1 ring-[#2a2a2c]" />
            </div>
          </div>
          
          {/* Screen content */}
          <div className="relative">
            {children}
          </div>
          
          {/* Home indicator */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-[100px] h-[4px] bg-white/30 rounded-full" />
        </div>
        
        {/* Side buttons - Volume */}
        <div className="absolute left-[-2px] top-24 w-[3px] h-7 bg-[#3a3a3a] rounded-l-sm shadow-sm" />
        <div className="absolute left-[-2px] top-36 w-[3px] h-10 bg-[#3a3a3a] rounded-l-sm shadow-sm" />
        <div className="absolute left-[-2px] top-[11.5rem] w-[3px] h-10 bg-[#3a3a3a] rounded-l-sm shadow-sm" />
        
        {/* Side button - Power */}
        <div className="absolute right-[-2px] top-32 w-[3px] h-14 bg-[#3a3a3a] rounded-r-sm shadow-sm" />
      </div>
    </div>
  )
}
